/* Global-in-page catalogue filtering. No article bodies are loaded by this script.
   Enhancement runs only when the complete published catalogue is present. */
(function () {
  // Collect off-DOM first. Never enable archive-wide filters on a partial result.
  async function completeCatalogue(root, baseURL = location.href, active = () => true) {
    if (!active()) throw new Error('Home feed expired');
    const integer = value => /^\d+$/.test(value || '') ? Number(value) : NaN;
    const total = integer(root.dataset.catalogueItems);
    const pages = integer(root.dataset.cataloguePages);
    const current = integer(root.dataset.cataloguePage);
    const key = root.dataset.catalogueKey;
    const param = root.dataset.cataloguePageParam;
    if (!key || !param || !Number.isSafeInteger(total) || !Number.isSafeInteger(pages) || pages < 1 || pages > Math.max(1, total) || !Number.isSafeInteger(current) || current < 1 || current > pages) throw new Error('Invalid archive metadata');
    const collected = new Map();
    const seen = new Set();
    let rawCount = 0;
    let excludedCount = 0;
    function collect(source, page) {
      const raw = integer(source.dataset.cataloguePageItems);
      const excluded = integer(source.dataset.catalogueExcluded);
      const cards = [...source.querySelectorAll(':scope > .cards > [data-guide]')];
      if (source.dataset.catalogueKey !== key || source.dataset.cataloguePageParam !== param || integer(source.dataset.catalogueItems) !== total || integer(source.dataset.cataloguePages) !== pages || integer(source.dataset.cataloguePage) !== page || !Number.isSafeInteger(raw) || !Number.isSafeInteger(excluded) || excluded > raw || cards.length !== raw - excluded || (pages > 1 && raw === 0)) throw new Error('Archive changed or page incomplete');
      cards.forEach(card => {
        const id = card.dataset.guideId;
        if (!id || seen.has(id)) throw new Error('Duplicate or missing article identity');
        seen.add(id);
      });
      if (!source.querySelector('.cards')) throw new Error('Missing card container');
      rawCount += raw;
      excludedCount += excluded;
      collected.set(page, source);
    }
    collect(root, current);
    // The server supplies a finite page count; verify each returned page identity.
    for (let page = 1; page <= pages; page++) {
      if (page === current) continue;
      if (!active()) throw new Error('Home feed expired');
      const url = new URL(baseURL);
      url.hash = '';
      url.searchParams.set(param, String(page));
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 15000);
      try {
        const response = await fetch(url.href, { credentials: 'same-origin', signal: controller.signal });
        if (!response.ok || new URL(response.url).origin !== url.origin || new URL(response.url).pathname !== url.pathname) throw new Error('Archive request failed');
        const returnedURL = new URL(response.url);
        if ([...url.searchParams].some(([name, value]) => !returnedURL.searchParams.getAll(name).includes(value))) throw new Error('Archive request context changed');
        const html = await response.text();
        if (!active()) throw new Error('Home feed expired');
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const sources = [...doc.querySelectorAll('[data-mg-guide-filter]')].filter(candidate => candidate.dataset.catalogueKey === key);
        if (sources.length !== 1) throw new Error('Missing or ambiguous archive');
        collect(sources[0], page);
      } finally { clearTimeout(timeout); }
    }
    if (rawCount !== total || seen.size !== total - excludedCount) throw new Error('Incomplete archive');
    return [...collected.entries()].sort((a, b) => a[0] - b[0]).map(entry => entry[1]);
  }
async function completeCompactCatalogue(root,active){
 if(!active())throw new Error('Home feed expired');
 const pageSize=Number(root.dataset.cataloguePageSize);
 if(!Number.isSafeInteger(pageSize)||pageSize<1||pageSize>250)throw new Error('Missing native page size');
 const url=new URL(location.href);url.hash='';
 url.searchParams.set('section_id','mg-home-product-metadata');
 const sources=await completeCatalogue(root,url.href,active);
 if(!active())throw new Error('Home feed expired');
 for(const source of sources){
  if(source===root)continue;
  if(source.dataset.mgCompactVersion!=='1'||source.dataset.catalogueLocale!==root.dataset.catalogueLocale||Number(source.dataset.cataloguePageSize)!==pageSize)throw new Error('Compact manifest mismatch');
  for(const node of source.querySelectorAll(':scope > .cards > [data-guide]')){
   if(!node.hasAttribute('data-mg-compact-card')||node.querySelector('img,script,style'))throw new Error('Unexpected compact content');
   const link=node.querySelector('a[href]');if(!link)throw new Error('Missing compact guide URL');
   const canonical=new URL(link.getAttribute('href'),location.origin);
   if(canonical.origin!==location.origin||canonical.search||canonical.hash||!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?blogs\/news\/[^/]+$/.test(canonical.pathname))throw new Error('Invalid compact guide URL');
  }
 }
 return sources;
}

  async function initialize(root) {
    if (root.dataset.ready) return;
    const feedAbort = new AbortController();
    const feedFrames = new Set(), feedTimers = new Set(), feedObservers = new Set();
    const feedActive = () => !feedAbort.signal.aborted && root.isConnected && root.dataset.homeFeedExpired !== 'true';
    function feedListen(target, name, callback, options = {}) {
      target.addEventListener(name, callback, { ...(typeof options === 'boolean' ? { capture: options } : options), signal: feedAbort.signal });
    }
    function feedFrame(callback) {
      if (!feedActive()) return 0;
      const id = requestAnimationFrame(() => { feedFrames.delete(id); if (feedActive()) callback(); });
      feedFrames.add(id); return id;
    }
    function feedTimeout(callback, delay) {
      if (!feedActive()) return 0;
      const id = setTimeout(() => { feedTimers.delete(id); if (feedActive()) callback(); }, delay);
      feedTimers.add(id); return id;
    }
    function feedClearTimeout(id) {
      feedTimers.delete(id); clearTimeout(id);
    }
    function feedObserver(Type, callback, options) {
      const observer = new Type((...args) => { if (feedActive()) callback(...args); }, options);
      feedObservers.add(observer); return observer;
    }
    root.addEventListener('mg:home-feed-dispose', () => {
      delete root.dataset.homeFeedSource;
      feedAbort.abort();
      feedFrames.forEach(cancelAnimationFrame);
      feedTimers.forEach(clearTimeout);
      feedObservers.forEach(observer => observer.disconnect());
    }, { once: true });
    const homeFeedExpired = () => root.hasAttribute('data-mobile-home') &&
      (root.dataset.homeFeedExpired === 'true' || root.closest('#all-guides')?.dataset.mgHomeFeedFailed === 'true');
    const keepNativeFallback = () => {
      delete root.dataset.homeFeedSource;
      root.dataset.ready = 'fallback';
      const notice = root.querySelector('[data-incomplete]');
      if (notice) notice.hidden = false;
    };
    if (homeFeedExpired()) { keepNativeFallback(); return; }
    delete root.dataset.homeFeedSource;
    root.dataset.ready = 'loading';
    let userInteractedWhileLoading = false;
    const loadingEvents = ['wheel', 'touchmove', 'pointerdown', 'keydown'];
    const noteLoadingInteraction = event => {
      if (!event.isTrusted) return;
      if (event.type === 'keydown' && (event.target?.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(event.target?.tagName || '') || event.defaultPrevented || event.ctrlKey || event.metaKey || event.altKey || !['ArrowDown', 'ArrowUp', 'PageDown', 'PageUp', 'Home', 'End', ' '].includes(event.key))) return;
      userInteractedWhileLoading = true;
    };
    loadingEvents.forEach(type => feedListen(window, type, noteLoadingInteraction, { passive: true }));
    let sources, preparedPlan = null, preparedCards = null, selectedSource = 'native';
    const adapter = root.hasAttribute('data-mobile-home') && window.MGHomeProducts?.apiVersion === 2 ? window.MGHomeProducts : null;
    const loadActive = () => feedActive() && !homeFeedExpired();
    const sourceNodes = list => list.flatMap(source => [...source.querySelector('.cards').children].filter(node => node.matches('[data-guide], style')));
    try {
      if (adapter && root.dataset.mgCompactEnabled === '1' && Number(root.dataset.cataloguePages) > 1) {
        try {
          sources = await completeCompactCatalogue(root, loadActive);
          if (!loadActive()) throw new Error('Home feed expired');
          preparedPlan = adapter.prepare(root, sourceNodes(sources));
          if (preparedPlan.kind !== 'products') throw new Error('Compact data cannot replace native cards');
          preparedCards = adapter.materialize(preparedPlan);
          selectedSource = 'compact';
        } catch (compactError) {
          // Cancellation is terminal. Only pre-commit errors may select the full native route.
          if (!loadActive()) return;
          sources = null; preparedPlan = null; preparedCards = null;
        }
      }
      if (!sources) {
        sources = await completeCatalogue(root, location.href, loadActive);
        if (!loadActive()) return;
        if (adapter) {
          try { preparedPlan = adapter.prepare(root, sourceNodes(sources)); preparedCards = adapter.materialize(preparedPlan); }
          catch (_) { preparedPlan = {kind: 'native', nodes: sourceNodes(sources)}; preparedCards = preparedPlan.nodes; }
        }
      }
    } catch (_) {
      if (!loadActive()) return;
      root.dataset.ready = 'fallback';
      const notice = root.querySelector('[data-incomplete]');
      if (notice) notice.hidden = false;
      return; // Keep the unmodified server page and native pagination available.
    } finally {
      loadingEvents.forEach(type => window.removeEventListener(type, noteLoadingInteraction));
    }
    if (!root.isConnected) return;
    if (homeFeedExpired()) { keepNativeFallback(); return; }
    if (!loadActive()) return;
    const container = root.querySelector('.cards');
    // Merge classifications that were only present on later server pages.
    sources.forEach(source => {
      if (source === root) return;
      root.querySelectorAll('[data-filter]').forEach(control => {
        const other = [...source.querySelectorAll('[data-filter]')].find(candidate => candidate.dataset.filter === control.dataset.filter);
        if (other) [...other.options].forEach(option => {
          if (![...control.options].some(existing => existing.value === option.value)) control.append(option.cloneNode(true));
        });
      });
    });
    // Move only cards and their scoped styles, not scripts or unrelated page UI.
    const nodes = sources.flatMap(source => [...source.querySelector('.cards').children].filter(node => node.matches('[data-guide], style')));
    if (!loadActive()) return;
    if (root.hasAttribute('data-mobile-home')) root.dispatchEvent(new CustomEvent('mg:home-products-will-mount', { bubbles: true }));
    if (!loadActive()) return;
    // One live commit only. Never catch commit/lifecycle errors and replay the legacy route.
    const homeNodes = preparedCards || (root.hasAttribute('data-mobile-home') && window.MGHomeProducts
      ? window.MGHomeProducts.transform(root, nodes) : nodes);
    if (adapter && preparedPlan) adapter.commit(root, preparedPlan);
    container.replaceChildren(...homeNodes);
    if (root.hasAttribute('data-mobile-home')) root.dispatchEvent(new CustomEvent('mg:home-products-mounted', { bubbles: true }));
    if (!loadActive()) return;
    const nativePagination = root.querySelector('[data-native-pagination]');
    if (nativePagination) nativePagination.hidden = true;
    const notice = root.querySelector('[data-incomplete]');
    if (notice) notice.hidden = true;
    root.dataset.ready = 'true';
    const controls = [...root.querySelectorAll('[data-filter]')];
    const cards = [...root.querySelectorAll(':scope > .cards > [data-guide]')];
    const count = root.querySelector('[data-count]');
    const empty = root.querySelector('[data-empty]');
    const pagination = root.querySelector('[data-pagination]');
    const previous = root.querySelector('[data-previous]');
    const next = root.querySelector('[data-next]');
    const pageStatus = root.querySelector('[data-page-status]');
    const incomplete = root.querySelector('[data-incomplete]');
    const resets = [...root.querySelectorAll('[data-reset]')];
    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const mobileHome = root.hasAttribute('data-mobile-home');
    const isMobile = () => mobileHome && mobileQuery.matches;
    let pageSize = isMobile() ? 6 : 12;
    let loaded = 6;
    let matchingCount = 0;
    let autoPaused = true;
    let returnPaused = root.dataset.resumePending === 'true' || performance.getEntriesByType('navigation')[0]?.type === 'back_forward';
    let autoSupported = false;
    let restoringScroll = false;
    let lastScrollY = window.scrollY;
    let autoPending = false;
    const language = (document.documentElement?.lang || 'en').split('-')[0];
    const feedLabels = {
      en: ['Continue browsing', 'Additional guides loaded.'],
      zh: ['继续浏览', '已加载更多指南。'],
      es: ['Seguir explorando', 'Se han cargado más guías.']
    }[language] || ['Continue browsing', 'Additional guides loaded.'];
    const more = root.querySelector('[data-mobile-more]');
    const mobileStatus = root.querySelector('[data-mobile-status]');
    const categories = root.querySelector('[data-mobile-categories]');
    const topic = controls.find(control => control.dataset.filter === 'topic');
    const filterContext = root.querySelector('[data-mobile-filter-context]');
    const filterSummary = root.querySelector('[data-mobile-filter-summary]');
    const moreFilters = root.querySelector('[data-more-filters]');
    const moreFiltersSummary = moreFilters?.querySelector('summary');
    const moreFiltersLabel = moreFiltersSummary?.textContent;
    const guideHeading = root.querySelector('.mg-mobile-latest-guides-heading');
    const defaultGuideHeading = guideHeading?.textContent;
    const endStatus = root.querySelector('[data-mobile-end]');
    const endLabel = ({ zh: '你已浏览完当前内容', es: 'Has llegado al final de estas guías.' }[language] || 'You’ve reached the end of these guides.');
    const scrollKey = 'mg-mobile-scroll:' + location.pathname;
    let restoreAfterLoad = () => {};

    if (mobileHome) { root.dataset.mobileReady = 'true'; root.dataset.mobileFeedMode = 'bounded-auto'; }
    // The home page keeps its existing mobile load-more flow.
    const pageNumbers = mobileHome && pagination && pageStatus ? document.createElement('span') : null;
    if (pageNumbers) {
      pageNumbers.className = 'mg-guide-page-numbers';
      pagination.dataset.numberedPages = 'true';
      pagination.insertBefore(pageNumbers, pageStatus);
    }
    // Counts describe the complete loaded catalogue, independent of other filters.
    controls.forEach(control => {
      [...control.options].forEach(option => {
        const matches = option.value === 'all' ? cards.length : cards.filter(card =>
          card.dataset.tags.split('|').includes(control.dataset.filter + ':' + option.value)
        ).length;
        const label = (option.textContent || option.value).replace(/\s+\(\d+\)$/, '');
        option.textContent = label;
        option.disabled = option.value !== 'all' && matches === 0;
      });
      control.disabled = false;
    });
    resets.forEach(button => { button.disabled = false; });
    if (mobileHome && topic && categories) {
      [...topic.options].filter(option => !option.disabled).forEach(option => {
        const button = document.createElement('button');
        button.type = 'button'; button.dataset.mobileCategory = option.value;
        button.textContent = option.value === 'all' ? (root.dataset.allGuidesLabel || ({ zh: '全部指南', es: 'Todas las guías' }[language] || 'All guides')) : option.textContent;
        button.setAttribute('aria-pressed', 'false');
        feedListen(button, 'click', () => {
          controls.forEach(control => { control.value = 'all'; });
          topic.value = option.value; page = 1; loaded = 6; autoPaused = true; update(true);
        });
        categories.append(button);
      });
      categories.hidden = false;
    }
    let page = 1;
    function restore() {
      let saved = '';
      try { saved = root.dataset.homeReset === 'true' ? '' : sessionStorage.getItem('mg-guide-state:' + location.pathname) || ''; } catch (_) {}
      const query = new URLSearchParams(location.hash.slice(1) || saved);
      controls.forEach(control => {
        const value = query.get(control.dataset.filter);
        control.value = [...control.options].some(option => option.value === value && (!mobileHome || !option.disabled)) ? value : 'all';
      });
      if (moreFilters && controls.some(control => control !== topic && control.value !== 'all')) moreFilters.open = true;
      const requested = Number(query.get('page'));
      page = Number.isSafeInteger(requested) && requested > 0 ? requested : 1;
      const requestedLoaded = Number(query.get('loaded'));
      loaded = Number.isSafeInteger(requestedLoaded) && requestedLoaded >= 6 ? Math.min(requestedLoaded, cards.length) : 6;
    }
    function save() {
      const query = new URLSearchParams();
      controls.forEach(control => { if (control.value !== 'all') query.set(control.dataset.filter, control.value); });
      if (page > 1) query.set('page', String(page));
      if (mobileHome && loaded > 6) query.set('loaded', String(loaded));
      const hash = query.toString();
      try { sessionStorage.setItem('mg-guide-state:' + location.pathname, hash); } catch (_) {}
      history.replaceState(history.state, '', location.pathname + location.search + (hash ? '#' + hash : ''));
    }
    function renderPageNumbers(pages) {
      if (!pageNumbers) return;
      pageNumbers.replaceChildren();
      if (isMobile() || pages <= 1) return;
      const visiblePages = new Set([1, pages]);
      if (pages <= 7) {
        for (let number = 1; number <= pages; number++) visiblePages.add(number);
      } else {
        for (let number = Math.max(1, page - 1); number <= Math.min(pages, page + 1); number++) visiblePages.add(number);
      }
      const numbers = [...visiblePages].sort((a, b) => a - b);
      function addPageButton(number) {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = String(number);
        button.setAttribute('aria-label', 'Page ' + number);
        if (number === page) button.setAttribute('aria-current', 'page');
        feedListen(button, 'click', () => {
          if (isMobile() || number === page) return;
          page = number; update(true); count.focus();
        });
        pageNumbers.append(button);
      }
      numbers.forEach((number, index) => {
        const gap = index ? number - numbers[index - 1] : 1;
        if (gap === 2) addPageButton(number - 1);
        else if (gap > 2) {
          const ellipsis = document.createElement('span');
          ellipsis.className = 'mg-guide-page-ellipsis';
          ellipsis.textContent = '…';
          ellipsis.setAttribute('aria-hidden', 'true');
          pageNumbers.append(ellipsis);
        }
        addPageButton(number);
      });
    }
    function update(writeState) {
      const matching = cards.filter(card => controls.every(control => control.value === 'all' || card.dataset.tags.split('|').includes(control.dataset.filter + ':' + control.value)));
      matchingCount = matching.length;
      if (mobileHome) {
        const categoryActive = topic && topic.value !== 'all';
        root.dataset.mobileCategoryActive = String(Boolean(categoryActive));
        if (guideHeading) guideHeading.textContent = categoryActive ? [...topic.options].find(option => option.value === topic.value)?.textContent || defaultGuideHeading : defaultGuideHeading;
        const extraCount = controls.filter(control => control !== topic && control.value !== 'all').length;
        if (moreFiltersSummary) moreFiltersSummary.textContent = moreFiltersLabel + (extraCount ? (language === 'zh' ? '（已选' + extraCount + '项）' : language === 'es' ? ' (' + extraCount + ' activos)' : ' (' + extraCount + ' active)') : '');
      }
      const pages = Math.max(1, Math.ceil(matching.length / pageSize));
      page = Math.min(page, pages);
      const first = isMobile() ? 0 : (page - 1) * pageSize;
      const end = isMobile() ? loaded : first + pageSize;
      const visible = new Set(matching.slice(first, end));
      if (filterContext && filterSummary) {
        const activeFilters = controls.filter(control => control.dataset.filter !== 'topic' && control.value !== 'all');
        filterContext.hidden = !isMobile() || activeFilters.length === 0;
        filterSummary.textContent = activeFilters.map(control => [...control.options].find(option => option.value === control.value)?.textContent || control.value).join(' · ');
      }
      if (more) { more.hidden = !isMobile() || visible.size >= matching.length; if (mobileHome) more.textContent = feedLabels[0]; }
      if (categories) categories.querySelectorAll('button').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.mobileCategory === topic.value)));
      if (endStatus) { endStatus.hidden = !isMobile() || matching.length === 0 || visible.size < matching.length; endStatus.textContent = endStatus.hidden ? '' : root.dataset.homeProducts === 'true' ? 'You’ve reached the end of these products.' : endLabel; }
      if (mobileStatus) mobileStatus.textContent = '';
      cards.forEach(card => { card.hidden = !visible.has(card); });
      empty.hidden = matching.length > 0;
      pagination.hidden = isMobile() || matching.length <= pageSize;
      previous.disabled = page === 1;
      next.disabled = page === pages;
      pageStatus.textContent = 'Page ' + page + ' of ' + pages;
      renderPageNumbers(pages);
      count.textContent = mobileHome ? (matching.length ? (topic && topic.value !== 'all' ? [...topic.options].find(option => option.value === topic.value)?.textContent || '' : (root.dataset.allGuidesLabel || ({ zh: '全部指南', es: 'Todas las guías' }[language] || 'All guides'))) : ({ zh: '没有符合这些筛选条件的指南。', es: 'Ninguna guía coincide con estos filtros.' }[language] || 'No guides match these filters.')) : matching.length ? 'Showing ' + (first + 1) + '–' + Math.min(end, matching.length) + ' of ' + matching.length + ' matching guides (' + cards.length + ' published).' : 'No matching guides in ' + cards.length + ' published guides.';
      if (writeState) save();
    }
    controls.forEach(control => feedListen(control, 'change', () => { page = 1; loaded = 6; autoPaused = true; update(true); }));
    resets.forEach(button => feedListen(button, 'click', () => { controls.forEach(control => { control.value = 'all'; }); page = 1; loaded = 6; autoPaused = true; update(true); (isMobile() ? categories?.querySelector('button') : (mobileHome ? topic : controls[0]))?.focus(); }));
    feedListen(previous, 'click', () => { if (page > 1) { page--; update(true); count.focus(); } });
    feedListen(next, 'click', () => { if (!next.disabled) { page++; update(true); count.focus(); } });
    function resetExplicitHome() {
      const intent = new URLSearchParams(location.hash.slice(1));
      if (!isMobile() || intent.get('home') !== 'all') return false;
      // A document-local intent flag also protects against late resume-script execution.
      root.dataset.homeReset = 'true';
      controls.forEach(control => { control.value = 'all'; intent.delete(control.dataset.filter); });
      page = 1; loaded = 6; autoPaused = true; returnPaused = true;
      update(false);
      if (categories) categories.scrollLeft = 0;
      intent.delete('home'); intent.delete('page'); intent.delete('loaded');
      try {
        sessionStorage.setItem('mg-guide-state:' + location.pathname, '');
        sessionStorage.removeItem(scrollKey);
      } catch (_) {}
      const hash = intent.toString();
      history.replaceState(history.state, '', location.pathname + location.search + (hash ? '#' + hash : ''));
      // Let the reset cards settle; keep the catalogue start below the current header.
      feedFrame(() => {
        const target = categories || root;
        const header = document.querySelector('#header-component')?.getBoundingClientRect();
        const headerHeight = header?.height || Math.max(0, header?.bottom || 0);
        const y = Math.max(0, window.scrollY + target.getBoundingClientRect().top - headerHeight - 8);
        window.scrollTo({ top: y, left: 0, behavior: 'instant' });
        lastScrollY = window.scrollY;
      });
      return true;
    }
    feedListen(window, 'hashchange', () => { if (!resetExplicitHome()) { restore(); update(false); } });
    feedListen(window, 'pageshow', () => { restore(); update(false); });
    if (mobileHome) {
      const feedback = root.querySelector('.mg-mobile-save-feedback');
      if (feedback) {
        let feedbackTimer;
        feedObserver(MutationObserver, () => {
          feedback.removeAttribute('data-feedback-hidden');
          feedClearTimeout(feedbackTimer);
          feedbackTimer = feedTimeout(() => feedback.setAttribute('data-feedback-hidden', ''), 5000);
        }).observe(feedback, { childList: true });
      }
      function canAutoLoad() {
        return autoSupported && isMobile() && root.dataset.resumePending !== 'true' && !returnPaused && !autoPaused && !restoringScroll && loaded < 18 && loaded < matchingCount && more && !more.hidden && document.activeElement !== more && document.visibilityState !== 'hidden';
      }
      function loadMore(automatic) {
        if (!isMobile() || loaded >= matchingCount || (automatic && !canAutoLoad())) return;
        const before = automatic ? null : new Set(cards.filter(card => !card.hidden));
        loaded = automatic ? Math.min(loaded + 6, 18) : loaded + 6;
        update(true);
        if (mobileStatus) mobileStatus.textContent = root.dataset.homeProducts === 'true' ? 'Additional products loaded.' : feedLabels[1];
        if (!automatic) {
          const firstNew = cards.find(card => !card.hidden && !before.has(card));
          firstNew?.querySelector('a')?.focus({ preventScroll: true });
        }
      }
      function queueAutoLoad() {
        if (autoPending || !canAutoLoad()) return;
        autoPending = true;
        feedFrame(() => {
          autoPending = false;
          if (!canAutoLoad()) return;
          const bounds = more.getBoundingClientRect();
          if (bounds.top <= window.innerHeight + 160 && bounds.bottom >= -160) loadMore(true);
        });
      }
      more && feedListen(more, 'click', () => loadMore(false));
      if (more && 'IntersectionObserver' in window) {
        try {
          const observer = feedObserver(window.IntersectionObserver, entries => {
            if (entries.some(entry => entry.isIntersecting)) queueAutoLoad();
          }, { rootMargin: '160px 0px', threshold: 0 });
          observer.observe(more);
          autoSupported = true;
        } catch (_) { autoSupported = false; /* The visible button remains the no-observer fallback. */ }
      }
      // Browser scroll restoration is not a request to load more after Back.
      let touchY = null;
      feedListen(window, 'wheel', event => {
        if (isMobile() && event.isTrusted && event.deltaY > 0) returnPaused = false;
      }, { passive: true });
      feedListen(window, 'touchstart', event => {
        touchY = event.touches[0]?.clientY ?? null;
      }, { passive: true });
      feedListen(window, 'touchmove', event => {
        const y = event.touches[0]?.clientY ?? null;
        if (isMobile() && event.isTrusted && touchY !== null && y !== null && y < touchY - 2) returnPaused = false;
        touchY = y;
      }, { passive: true });
      feedListen(window, 'keydown', event => {
        if (isMobile() && event.isTrusted && !event.target?.isContentEditable && !/^(INPUT|TEXTAREA|SELECT)$/.test(event.target?.tagName || '') && !event.defaultPrevented && !event.shiftKey && !event.ctrlKey && !event.metaKey && !event.altKey && ['ArrowDown', 'PageDown', 'End', ' '].includes(event.key)) returnPaused = false;
      });
      feedListen(window, 'scroll', () => {
        const y = window.scrollY;
        if (autoPaused && isMobile() && !returnPaused && !restoringScroll && y > lastScrollY + 1) {
          autoPaused = false;
          queueAutoLoad();
        }
        lastScrollY = y;
      }, { passive: true });
      feedListen(window, 'pageshow', event => {
        if (event.persisted || performance.getEntriesByType('navigation')[0]?.type === 'back_forward') { autoPaused = true; returnPaused = true; }
        lastScrollY = window.scrollY;
      });
      feedListen(mobileQuery, 'change', () => { pageSize = isMobile() ? 6 : 12; update(false); });
      feedListen(window, 'pagehide', () => {
        autoPaused = true; returnPaused = true;
        save();
        try { sessionStorage.setItem(scrollKey, JSON.stringify({ hash: location.hash, y: window.scrollY })); } catch (_) {}
      });
      restoreAfterLoad = event => {
        if (event.persisted || userInteractedWhileLoading || root.dataset.homeReset === 'true' || performance.getEntriesByType('navigation')[0]?.type !== 'back_forward') return;
        try {
          const savedScroll = JSON.parse(sessionStorage.getItem(scrollKey) || 'null');
          if (savedScroll && savedScroll.hash === location.hash && Number.isFinite(savedScroll.y)) {
            restoringScroll = true;
            feedFrame(() => {
              window.scrollTo(0, savedScroll.y);
              lastScrollY = window.scrollY;
              feedFrame(() => { restoringScroll = false; });
            });
          }
        } catch (_) {}
      };
      feedListen(window, 'pageshow', restoreAfterLoad);
    }
    restore(); update(false);
    const explicitHome = resetExplicitHome();
    // A slow catalogue request may complete after the document's pageshow event.
    if (!explicitHome && document.readyState === 'complete') restoreAfterLoad({ persisted: false });
    if (!loadActive()) return;
    if (root.hasAttribute('data-mobile-home')) root.dataset.homeFeedSource = selectedSource;
    root.dispatchEvent(new CustomEvent('mg:catalogue-ready', { bubbles: true }));
    if (adapter && preparedPlan) adapter.notify(root, preparedPlan, loadActive);
  }
  document.querySelectorAll('[data-mg-guide-filter]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-mg-guide-filter]').forEach(initialize));
}());
